import React from "react"
import api from "src/api"
import { buildSearchFilter } from "src/utils/build-search-filter"

const SEARCH_FIELDS = ["id", "name"]

export function useGetCategories() {
  const [paginationParams, setPaginationParams] = React.useState({
    pagination: {
      current: 1,
      pageSize: 30,
    },
  })

  const [items, setItems] = React.useState([])
  const [appliedFilters, setAppliedFilters] = React.useState("")

  React.useEffect(() => {
    getItems()
  }, [])

  async function getItems(filters = "") {
    try {
      const { data } = await api.get(`promotion-categories?${filters.replace(/^&/, "")}`)
      setPaginationParams({
        pagination: data.pagination,
      })
      updateItems(data.items)
    } catch (error) {
      console.error("Ошибка получения данных", error)
    }
  }

  function handleSearchTable(value) {
    const filters = buildSearchFilter(value, SEARCH_FIELDS)
    setAppliedFilters(filters)
    getItems(filters)
  }

  function updateItems(items) {
    const newData = getFormattedItems(items)
    setItems(newData)
  }

  function getFormattedItems(items) {
    let data = []
    items.forEach((item) => {
      let nameItem = item.name
      let name = nameItem.find((el) => el.language === "ru")
      data.push({
        id: item.id,
        name: item.name,
        nameRu: name.content,
        isActive: item.isActive,
        sortWeight: item.sortWeight,
      })
    })
    return data
  }

  return { items, paginationParams, handleSearchTable, refetch: () => getItems(appliedFilters) }
}
